// extracted by mini-css-extract-plugin
module.exports = {"input":"Create_input__rKHnO","ant-tooltip-inner":"Create_ant-tooltip-inner__cKWi6"};